import { Messages } from '@lingui/core';

import { messages as _messages } from '../../../messages/adminPortal/en.json';

export const messages = _messages as unknown as Messages;
